import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { displayToastError, displayToastSuccess } from '@/helpers/display-toast';
import { changePassword } from '@/lib/auth';
import { mapCognitoChangePasswordError } from '@/lib/auth-errors';

interface ChangePasswordParams {
  currentPassword: string;
  newPassword: string;
}

export function useChangePassword() {
  const { t } = useTranslation('authenticated.settings');

  const mutation = useMutation({
    mutationFn: ({ currentPassword, newPassword }: ChangePasswordParams) =>
      changePassword(currentPassword, newPassword),
    onSuccess: () => {
      displayToastSuccess(t('toasts.passwordChangedSuccess'));
    },
    onError: (error: unknown) => {
      const { userMessage } = mapCognitoChangePasswordError(error, t);
      displayToastError(userMessage);
    },
  });

  return {
    changePassword: mutation.mutate,
    isChanging: mutation.isPending,
  };
}
